import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function BerserkerLogo(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      id="Logo"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "40.189"}
      height={height || "35"}
      viewBox="0 0 40.189 35"
    >
      <g id="Left" transform="translate(0 5.489)">
        <path
          id="Path_1456"
          data-name="Path 1456"
          d="M3060.649,2989.972a14.124,14.124,0,0,1-6.976,10.022,14.541,14.541,0,0,1-5.417,1.838,14.1,14.1,0,0,0,8.782-1.784,14.3,14.3,0,0,0,7.077-11.486A14.975,14.975,0,0,1,3060.649,2989.972Z"
          transform="translate(-3036.224 -2972.504)"
          fill="#fb972e"
        />
        <path
          id="Path_1457"
          data-name="Path 1457"
          d="M3041.112,2975.109a14.119,14.119,0,0,0-4.888,6.153,14.515,14.515,0,0,1,4.389-3.889c.182-.1.366-.205.55-.3A9.722,9.722,0,0,1,3041.112,2975.109Z"
          transform="translate(-3036.224 -2972.504)"
          fill="#fb972e"
        />
        <path
          id="Path_1458"
          data-name="Path 1458"
          d="M3062.117,2980.012a14.684,14.684,0,0,0-18.215-6.445,8.1,8.1,0,0,0,.357,2.313,13.194,13.194,0,0,1,14.879,5.878,12.373,12.373,0,0,1,1.379,3.566,12.784,12.784,0,0,0,3.107-1.7A15.178,15.178,0,0,0,3062.117,2980.012Z"
          transform="translate(-3036.224 -2972.504)"
          fill="#fb972e"
        />
      </g>
      <g id="Right" transform="translate(12.328 5.567)">
        <path
          id="Path_1459"
          data-name="Path 1459"
          d="M3059.946,2976.381a14.125,14.125,0,0,1,12.167,1.032,14.487,14.487,0,0,1,4.3,3.772,14.093,14.093,0,0,0-5.936-6.715,14.3,14.3,0,0,0-13.485-.385A14.978,14.978,0,0,1,3059.946,2976.381Z"
          transform="translate(-3048.552 -2972.582)"
          fill="#333"
        />
        <path
          id="Path_1460"
          data-name="Path 1460"
          d="M3056.843,3000.733a14.125,14.125,0,0,0,7.773,1.156,14.487,14.487,0,0,1-5.563-1.856c-.182-.1-.36-.214-.536-.326A9.773,9.773,0,0,1,3056.843,3000.733Z"
          transform="translate(-3048.552 -2972.582)"
          fill="#333"
        />
        <path
          id="Path_1461"
          data-name="Path 1461"
          d="M3050.586,2980.09a14.684,14.684,0,0,0,3.527,19,8.155,8.155,0,0,0,1.824-1.466,13.2,13.2,0,0,1-2.349-15.825,12.348,12.348,0,0,1,2.4-2.976,12.72,12.72,0,0,0-3.026-1.841A15.185,15.185,0,0,0,3050.586,2980.09Z"
          transform="translate(-3048.552 -2972.582)"
          fill="#333"
        />
      </g>
      <g id="Top" transform="translate(5.378)">
        <path
          id="Path_1462"
          data-name="Path 1462"
          d="M3048.523,2983.813a14.122,14.122,0,0,1-5.191-11.053,14.5,14.5,0,0,1,1.117-5.61,14.094,14.094,0,0,0-2.847,8.5,14.293,14.293,0,0,0,6.409,11.871A15,15,0,0,1,3048.523,2983.813Z"
          transform="translate(-3041.602 -2967.015)"
          fill="#333"
        />
        <path
          id="Path_1463"
          data-name="Path 1463"
          d="M3071.163,2974.325a14.118,14.118,0,0,0-2.885-7.31,14.5,14.5,0,0,1,1.174,5.745q0,.316-.014.628A9.707,9.707,0,0,1,3071.163,2974.325Z"
          transform="translate(-3041.602 -2967.015)"
          fill="#333"
        />
        <path
          id="Path_1464"
          data-name="Path 1464"
          d="M3056.414,2990.065a14.686,14.686,0,0,0,14.69-12.553,8.125,8.125,0,0,0-2.182-.847,13.2,13.2,0,0,1-12.53,9.947,12.388,12.388,0,0,1-3.777-.589,12.778,12.778,0,0,0-.081,3.541A15.215,15.215,0,0,0,3056.414,2990.065Z"
          transform="translate(-3041.602 -2967.015)"
          fill="#333"
        />
      </g>
    </svg>
  );
}
